import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getCertUrl } from '../../utils/certUrls';
import TagBadge from '../Documents/atoms/TagBadge';

const BasicInfo = ({ coin }) => {
  const navigate = useNavigate();

  const getStatusColor = (colorString) => {
    if (!colorString) return 'blue-100';
    const [baseColor, intensity = '100'] = colorString.split('-');
    const tailwindColors = ['red', 'yellow', 'green', 'blue', 'indigo', 'purple', 'pink', 'gray', 'orange', 'teal', 'cyan', 'lime', 'emerald', 'violet', 'fuchsia', 'rose', 'amber', 'sky', 'slate'];
    return tailwindColors.includes(baseColor) ? `${baseColor}-${intensity}` : 'blue-100';
  };

  return (
    <div className="border-t border-gray-200 px-6 py-6 sticky top-0 bg-white z-10 shadow-md">
      <div>
        <div className="flex items-baseline justify-between">
          <div className="flex items-baseline space-x-2">
            <h3 className="text-2xl font-bold text-gray-900">
              {coin.country}{' '}
              {coin.year}
              {coin.mint_mark && `-${coin.mint_mark}`}
              {coin.assayer && ` (${coin.assayer})`}{' '}
              {coin.denomination}
            </h3>
            {coin.variety && <span className="text-xl text-gray-600 ml-2">• {coin.variety}</span>}
            <div className="inline-flex items-baseline gap-2 ml-2 translate-y-[1px]">
              {(() => {
                const color = getStatusColor(coin.status_color);
                const [baseColor] = color.split('-');
                return (
                  <>
                    <span className={`px-3 py-0.5 inline-flex text-sm font-semibold rounded-full bg-${color} ${parseInt(color.split('-')[1]) >= 500 ? 'text-white' : `text-${baseColor}-800`}`}>
                      {coin.status_name}
                    </span>
                    {coin.status_name === 'Sold' && coin.sale_transaction_id && (
                      <span className="text-sm text-gray-500">
                        (<button 
                          onClick={() => navigate(`/transactions?view=${coin.sale_transaction_id}&type=sales`)}
                          className="text-indigo-600 hover:text-indigo-900"
                        >
                          {coin.sale_transaction_id}
                        </button>)
                      </span>
                    )}
                    {coin.tags && coin.tags.length > 0 && (
                      <div className="flex gap-2">
                        {coin.tags.map(tag => (
                          <div
                            key={tag.id}
                            onClick={() => navigate(`/sets?tagId=${tag.id}`)}
                            className="cursor-pointer"
                          >
                            <TagBadge
                              name={tag.name}
                              color={tag.color}
                              interactive={false}
                            />
                          </div>
                        ))}
                      </div>
                    )}
                  </>
                );
              })()}
            </div>
          </div>
        </div>
        
        <div className="mt-3 flex items-center">
          <div className="flex items-center space-x-2">
            <span className="text-xl font-bold text-gray-900">{coin.grade}</span>
            {coin.cac_sticker && coin.cac_sticker !== 'none' && (
              <span className={`px-2 py-0.5 text-sm font-semibold rounded-full ${
                coin.cac_sticker === 'gold' 
                  ? 'bg-yellow-100 text-yellow-800 border border-yellow-200'
                  : 'bg-green-100 text-green-800 border border-green-200'
              }`}>
                CAC
              </span>
            )}
          </div>
          {coin.certification_number ? (
            <span className="text-lg text-gray-600 ml-2">
              {coin.certification_service_name} Cert # {
                (() => {
                  const certUrl = getCertUrl(coin.certification_number, coin.certification_service_name, coin.grade);
                  return certUrl ? (
                    <a
                      href={certUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-indigo-600 hover:text-indigo-900"
                    >
                      {coin.certification_number}
                    </a>
                  ) : coin.certification_number;
                })()
              }
            </span>
          ) : (
            <span className="text-lg text-gray-600 ml-2">
              Uncertified
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default BasicInfo;
